import AppCardLayout from './AppCardLayout.vue';

export default AppCardLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardLayout/index.ts